import { render } from "./waitinglistdetail.vue?vue&type=template&id=3c5381bf"
import script from "./waitinglistdetail.vue?vue&type=script&lang=js"
export * from "./waitinglistdetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__